var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "#93C11A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3402 0.604004C21.0985 0.604004 0.601166 21.1013 0.601166 46.3431C0.601166 71.5477 21.0985 92.0821 46.3402 92.0821C71.5449 92.0821 92.0793 71.5848 92.0793 46.3431C92.0422 21.1013 71.5449 0.604004 46.3402 0.604004ZM46.3402 5.05189C64.6507 5.05189 80.2183 17.0612 85.5928 33.5925H58.1642L58.1271 30.4419L50.8622 28.6998L50.6028 25.6604C53.4939 24.1778 55.4584 21.2125 55.4584 17.7284C55.4584 12.8357 51.4924 8.83259 46.5626 8.83259C41.6699 8.83259 37.6669 12.7986 37.6669 17.7284C37.6669 20.9531 39.4089 23.7701 41.9665 25.3268L42.2259 28.6627L34.4051 30.4048V33.5925H7.0506C12.4251 17.0612 27.9927 5.05189 46.3402 5.05189ZM5.04905 46.3431C5.04905 44.3415 5.19731 42.377 5.45677 40.4496H34.368L34.2939 49.716L39.3719 54.1639L39.6684 61.6883L36.7402 63.8381L36.8885 70.2875L40.7433 75.2172V81.6667H39.0012V86.9671C19.7641 83.52 5.04905 66.618 5.04905 46.3431ZM53.568 86.9671V81.7037H51.8259V75.2543L55.6437 70.3616L55.792 63.9122L52.8638 61.7624L53.1603 54.2381L58.2383 49.7902L58.1642 40.5238H87.1125C87.3719 42.4512 87.5202 44.4156 87.5202 46.4172C87.5943 66.618 72.8793 83.52 53.568 86.9671Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.4411,
    height: 91.4411,
    transform: "translate(0.601166 0.604004)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickerIcon);
export default __webpack_public_path__ + "static/media/KICKER_ICON.24d03c56da40e1ec0609278ee3245c8f.svg";
export { ForwardRef as ReactComponent };